import { Box, Grid, Skeleton, Stack } from '@atgfr8/atg-ui-tailwind';

export const ProductFormSkeleton = () => {
  return (
    <Box style={{ 'flex-grow': 1 }}>
      <Grid container spacing={2}>
        <Grid item size={{ xs: 12, sm: 6, md: 3.5 }}>
          <Stack spacing={2}>
            <Skeleton variant="text" width="80%" height={60} />
            <Skeleton variant="rectangular" width="100%" height={118} />
            <Skeleton variant="rectangular" width="60%" height={52} />
          </Stack>
        </Grid>
        <Grid item size={{ xs: 12, sm: 6, md: 3.5 }}>
          <Stack spacing={2}>
            <Skeleton variant="rectangular" width="60%" height={52} />
            <Skeleton variant="text" width="80%" height={60} />
            <Skeleton variant="rectangular" width="100%" height={52} />
          </Stack>
        </Grid>
        <Grid item size={{ xs: 12, md: 5 }}>
          <Stack spacing={2}>
            <Skeleton variant="rectangular" width="100%" height={200} />{' '}
            <Skeleton variant="rectangular" width="100%" height={118} />
          </Stack>
        </Grid>
      </Grid>
      <Box display="flex" justifyContent="flex-end" mt="8px" gap={2}>
        <Skeleton variant="rectangular" width={90} height={40} />
        <Skeleton variant="rectangular" width={90} height={40} />
      </Box>
    </Box>
  );
};
